import endpoints from '../ajax/endpoints';
export default function (app) {
	app.factory('ajaxNotification', ['$rootScope', '$timeout', '$q', 'frameContext', function ($rootScope, $timeout, $q, frameContext) {
		var queue = [];
		var isPhase = false;

		function enqueue(data, options) {
			var config = {
				delay: options && options.delay || 500,
				autoStep: options && options.autoStep || true
			};

			var promise = $q.defer();

			queue.push({
				delay: config.delay,
				autoStep: config.autoStep,
				data: data,
				promise: promise
			});

			if (config.autoStep) {
				nextStep();
			}

			return promise.promise;
		}

		function nextStep() {
			if (isPhase || queue.length == 0) {
				return;
			}

			isPhase = true;

			var nextItem = queue.shift();

			$timeout(function () {
				nextItem.promise.resolve(nextItem.data);

				isPhase = false;

				if (nextItem.autoStep) {
					nextStep();
				}

			}, nextItem.delay);
		}

		function getNiceMessage(translationString) {
			// translationString a lang/status-message.json-okban lévő kulcs, vagy endpoints.js-ben lévő string.
			// ha találunk a kilcs alapján fordított szöveget, azt adjuk vissza, ha nem, akkor az endpoints.js-ben megadottat.
			return frameContext.statusMessageTranslations[translationString] || translationString;
		}

		function setResponse(endpoint, type, placeHolders) {
			var endpointOptions = endpoints[endpoint];

			// TODO: az isSuccess ne booleanként legyen kezelve a jadek-ben!
			var isSuccess = type.toLowerCase().indexOf('success') != -1;
			var niceMessageTranslationString;

			if (endpointOptions.popup[type]) {
				niceMessageTranslationString = endpointOptions.popup[type];
			} else {
				if (isSuccess) {
					niceMessageTranslationString = 'default.success';
				} else {
					niceMessageTranslationString = 'default.error';
				}
			}

			var niceMessage = getNiceMessage(niceMessageTranslationString);

			if (endpointOptions && endpointOptions.popup) {
				var notification = {
					endpoint: endpoint,
					success: isSuccess,
					niceMessage: niceMessage,
					placeHolders: placeHolders
				};
				// TODO: translation-ból venni a notification szövegeit.

				enqueue(notification)
					.then(function (item) {
						$rootScope.$broadcast('ajaxNotification', item);
					});
			} else {
				// TODO: később lehet erre a kiírásra nem lesz szükség, de fejlesztés közben jó ha itt van.
				if (console && console.info) {
					console.info('Nem létezik ilyen végpont, vagy nem kell mutatnunk.', endpoint);
				}
			}
		}

		return {
			setResponse: setResponse
		};
	}]);
};
